export const transformNameToLetter = (str?: string) => (str ? str.charAt(0).toUpperCase() : "")
